/** Whether the signed-in user may download documents (view is separate). */
export function canDownloadDocuments(user) {
    if (!user) return false
    if (user.role === "admin" || user.role === "customer") return true
    if (user.role === "prospect") return !user.restrictProspectDownload
    return false
}
